import { Component, OnInit } from '@angular/core';
import { environment as configs } from 'src/environments/environment';
import { HttpClient, HttpParams, HttpEventType, HttpResponse, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  config: any = configs;
  constructor(private rt: Router, private httpClient: HttpClient) { }
  host = configs['ApiHost'];

  wrkSerialCode: any
  wrkUrer: any;
  userrolecode: any;
  ngOnInit() {
    this.wrkUrer = JSON.parse(localStorage.getItem('user'));
    this.wrkSerialCode = this.wrkUrer.usPageSerialCode;
    this.userrolecode = this.wrkUrer.role;
  }
  logout() {

    localStorage.removeItem('auth-token');
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
    this.httpClient.post(this.host + '/logout', {}, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).subscribe(resp => { });
    //this.rt.navigate(['/login']);
    
     window.location.href=configs['logoutLink']
  }

   BackToELabour(){
    this.httpClient.post(this.host + '/logoutNgoback', {}, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).subscribe(resp => { 

      localStorage.removeItem('auth-token');
      localStorage.removeItem('user');
      localStorage.removeItem('isLoggedIn');
       window.location.href=configs['BACK_TO_ELAB_PATH_stg']+'?msg='+resp['msg']+'|'+resp['checksum']; 

    });
  }
}
